<template>
  <el-dialog title="智能客服" :visible.sync="dialogVisible" width="1000px" class="infoDialog">
    <div class="infoBox">
      <div class="rbox">
        <div ref="msgbox" class="msgbox">
          <div v-for="(item, index) in msgList" :key="index + 'msgbox'" :class="item.type == 0 ? 'leftMsg' : 'rightMsg'">
            <div v-if="item.type == 0 && item.contentType == 0" class="msgInfo">{{ item.cont }}</div>
            <div v-if="item.type == 0 && item.contentType == 1" class="msgInfoList">
              <!-- <div>一共为您找到{{ item.contList.length }}条相关问题回复：</div> -->
              <div style="width: 100%">您是否想咨询：</div>
              <div v-for="contItem in item.contList" :key="contItem" class="contListItem" @click="clickQuestion(contItem)">{{ contItem.question }}</div>
            </div>
            <div v-if="item.type == 1 && item.contentType == 0" class="msgInfoR">{{ item.cont }}</div>
          </div>
        </div>
        <div class="inputbox">
          <el-input v-model="problem" placeholder="请输入您想咨询的问题" class="problemInput" @change="pushQuestion">
            <template slot="suffix">
              <div class="suffiximg">
                <img src="@/assets/images/znkf/inputicon.png" class="inputIcon" />
              </div>
            </template>
          </el-input>
        </div>
      </div>
      <div class="lbox">
        <div class="problemBox">
          <div class="blue-head">常见问题</div>
          <div v-for="item in typeList" :key="item.type" class="listBox">
            <div class="typeTitle">{{ item.type }}</div>
            <div v-for="listItem in item.list" :key="listItem.id" class="wqConItem">{{ listItem.question }}</div>
          </div>
        </div>
        <div class="linkBox">
          <div class="blue-head">联系我们</div>
          <div class="linkinfoBox">
            <div class="infoitem">
              <div class="infolabel">服务热线1：</div>
              <div class="infocont">0574-87183315</div>
            </div>
            <div class="infoitem">
              <div class="infolabel">服务热线2：</div>
              <div class="infocont">0574-81890910</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CustomerServiceDiaLog',
  data() {
    return {
      dialogVisible: false,
      problem: '',
      typeList: [],
      msgList: [
        {
          type: 0,
          contentType: 0,
          cont: 'Hi，请问有什么可以帮到您？',
        },
        //   {
        //     type: 1,
        //     contentType: 0,
        //     cont: '1111',
        //   },
        //   {
        //     type: 0,
        //     contentType: 1,
        //     contList: ['1111', '111'],
        //   },
      ],
    }
  },
  mounted() {
    this.getType()
  },
  methods: {
    getType() {
      this.$http({ method: 'get', url: `/zzmh/api/question/getType` }).then((res) => {
        this.typeList = res.data
      })
    },
    showDiaLog() {
      this.dialogVisible = true
    },
    pushQuestion(val) {
      this.problem = ''
      this.msgList.push({
        type: 1,
        contentType: 0,
        cont: val,
      })
      this.$http({ method: 'get', url: `/zzmh/api/question/answer?question=${val}` }).then((res) => {
        //console.log(res.data)
        this.msgList.push({
          type: 0,
          contentType: 1,
          contList: res.data,
        })
      })
      this.$nextTick(() => {
        this.srcollMsg()
      })
    },
    srcollMsg() {
      const document = this.$refs.msgbox
      document.scrollTop = document.scrollHeight
    },
    clickQuestion(question) {
      this.msgList.push(
        {
          type: 1,
          contentType: 0,
          cont: question.question,
        },
        {
          type: 0,
          contentType: 0,
          cont: question.response,
        }
      )
      this.$nextTick(() => {
        this.srcollMsg()
      })
    },
  },
}
</script>

<style lang="less" scoped>
.infoDialog {
  /deep/ .el-dialog__body {
    padding: 0;
    border-left: 1px solid rgba(238, 238, 238, 1);
  }
}
.infoBox {
  width: 100%;
  height: 440px;
  display: flex;
  .rbox {
    width: 70%;
    .msgbox {
      height: 330px;
      overflow-y: auto;
      background: #f3f4f9;
      border-left: 1px solid rgba(238, 238, 238, 1);
      padding: 32px;
      box-sizing: border-box;
      .leftMsg {
        display: flex;
        margin-top: 10px;
        align-items: center;
        &::before {
          content: '';
          display: inline-block;
          width: 32px;
          height: 32px;
          background-image: url('@/assets/images/znkf/kficon.png');
          background-size: auto 100%;
        }
      }
      .msgInfo {
        max-width: 50%;
        background: #ffffff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding: 6px 10px;
        margin-left: 10px;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
      }
      .msgInfoList {
        max-width: 50%;
        background: #ffffff;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 10px;
        margin-left: 10px;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
        .contListItem {
          cursor: pointer;
          width: 90%;
          background: rgba(27, 91, 250, 0.08);
          border-radius: 4px;
          color: #1b5bfa;
          display: flex;
          align-items: center;
          padding: 6px;
          margin-top: 5px;
        }
      }
      .rightMsg {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 10px;
        &::after {
          content: '';
          display: inline-block;
          width: 32px;
          height: 32px;
          background-image: url('@/assets/images/znkf/wqicon.png');
          background-size: auto 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .msgInfoR {
        max-width: 50%;
        background: #1b5bfa;
        color: #fff;
        font-size: 14px;
        letter-spacing: 0;
        font-weight: 400;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding: 6px 10px;
        margin-right: 10px;
      }
    }
    .inputbox {
      height: 110px;
      display: flex;
      align-items: center;
      justify-content: center;
      .problemInput {
        width: 90%;
        font-size: 11px;
      }
      .inputIcon {
        width: 16px;
        height: 14px;
      }
      .suffiximg {
        display: flex;
        align-items: center;
        height: 100%;
        padding-right: 10px;
      }
    }
  }
  .lbox {
    width: 30%;
    height: 440px;
    border-left: 1px solid rgba(238, 238, 238, 1);
    padding: 20px;
    box-sizing: border-box;
    .blue-head {
      display: flex;
      align-items: center;
      padding-left: 15px;
      height: 32px;
      background-image: linear-gradient(180deg, #3a94fd 0%, #1b5bfa 100%);
      border-radius: 4px 4px 0px 0px;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 500;
    }
    .problemBox {
      background: #ffffff;
      border: 1px solid rgba(243, 244, 249, 1);
      border-radius: 4px;
      height: 70%;
      .listBox {
        height: calc(100% - 32px);
        padding: 16px;
        overflow-y: auto;
        box-sizing: border-box;
        // display: grid;
        // grid-template-columns: 100%;
        // grid-template-rows: auto;
        row-gap: 8px;
        .typeTitle {
          display: flex;
          align-items: center;
          height: 24px;
          font-size: 12px;
          color: #1b5bfa;
          letter-spacing: 0;
          line-height: 24px;
          font-weight: 600;
          &::before {
            content: '';
            display: inline-block;
            width: 16px;
            height: 16px;
            background-image: url('@/assets/images/znkf/wq.png');
            background-size: 100% auto;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 8px;
          }
        }
        .wqConItem {
          padding: 6px 12px;
          background: rgba(153, 153, 153, 0.1);
          border-radius: 4px;
          margin-top: 4px;
          font-size: 12px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
        }
      }
    }
    .linkBox {
      margin-top: 20px;
      background: #ffffff;
      border: 1px solid rgba(243, 244, 249, 1);
      border-radius: 4px;
      height: 25%;
      .linkinfoBox {
        height: calc(100% - 32px);
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .infoitem {
          display: flex;
          box-sizing: border-box;
          padding-left: 10px;
          width: 100%;
          .infolabel {
            font-size: 12px;
            color: #333333;
            letter-spacing: 0;
            line-height: 24px;
            font-weight: 600;
          }
          .infocont {
            font-size: 12px;
            color: #333333;
            letter-spacing: 0;
            line-height: 24px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
